import Prompt from '../models/Prompt'

export default class PromptService {
    prompt: Prompt

    constructor(prompt: Prompt) {
        this.prompt = prompt
    }

    static make(): Prompt {
        return new Prompt()
    }

    showNewPrompt(prompt: Prompt): this {
        this.prompt = prompt
        this.prompt.open()

        return this
    }

    getActivePrompt(): Prompt {
        return this.prompt
    }
}


// WEBPACK FOOTER //
// ./src/services/PromptService.ts